import { Link } from 'react-router-dom';
import { ShieldCheck, Mail } from 'lucide-react';
import { NAV_LINKS, SERVICES, CONTACT } from '../data/content';

export const Footer = () => (
    <footer className="border-t border-white/5 bg-[#0B101D]" data-testid="site-footer">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
            <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
                <div className="md:col-span-5">
                    <Link to="/" className="flex items-center gap-2.5" data-testid="footer-logo-link">
                        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-glow/10 border border-glow/30 text-glow">
                            <ShieldCheck size={18} strokeWidth={2.2} />
                        </span>
                        <span className="font-display text-lg font-bold text-[#F8FAFC]">Planmodo</span>
                    </Link>
                    <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#94A3B8]">
                        Practitioner-led resilience and recovery services. We help organizations prepare for,
                        respond to, recover from, and adapt to disruption — with plans that work in the real world.
                    </p>
                    <p className="mt-6 font-mono text-xs uppercase tracking-[0.25em] text-glow/80">
                        Resilience Beyond Recovery.
                    </p>
                </div>

                <div className="md:col-span-2">
                    <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-[#64748B]">Navigate</h3>
                    <ul className="mt-5 space-y-3">
                        {NAV_LINKS.map((link) => (
                            <li key={link.path}>
                                <Link to={link.path} data-testid={`footer-nav-${link.label.toLowerCase()}`} className="text-sm text-[#94A3B8] transition-colors hover:text-glow">
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-3">
                    <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-[#64748B]">Core Services</h3>
                    <ul className="mt-5 space-y-3">
                        {SERVICES.slice(0, 6).map((s) => (
                            <li key={s.id}>
                                <Link to="/services" data-testid={`footer-service-${s.id}`} className="text-sm text-[#94A3B8] transition-colors hover:text-glow">
                                    {s.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-2">
                    <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-[#64748B]">Contact</h3>
                    <ul className="mt-5 space-y-3 text-sm text-[#94A3B8]">
                        <li className="flex items-center gap-2">
                            <Mail size={14} className="text-glow/70" />
                            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="transition-colors hover:text-glow">{CONTACT.email}</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/5 pt-8 sm:flex-row sm:items-center">
                <p className="text-xs text-[#64748B]">© {new Date().getFullYear()} Planmodo. All rights reserved.</p>
                <p className="text-xs text-[#475569]">Prepare. Respond. Recover. Adapt.</p>
            </div>
        </div>
    </footer>
);
